import { useQuery } from "@tanstack/react-query";
import { fetchCategoryBySlug } from "@/apis";
import type { Category } from "@/types";

export const useCategoryByKey = (categoryKey: string): Category | null => {
  const { data } = useQuery<Category>({
    queryKey: ["category", "by-key", categoryKey],
    queryFn: async () => {
      const response = await fetchCategoryBySlug(categoryKey);
      const category = response?.data?.response;

      if (!category) throw new Error("Category not found");
      return category;
    },
    enabled: Boolean(categoryKey),
  });

  return data ?? null;
};
